import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createTextVNode as _createTextVNode, mergeProps as _mergeProps } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑");

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { dateFormat, getVexTableProps } from '@/config';
import { getSalesmanCustomList, clearRelation, getSpecifiedSalesmanType } from '@/request';
import { useRouter, useRoute } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import BindCustomerInfoModal from './component/BindCustomerInfoModal.vue';
export default {
  name: 'SalesmanAndCustomerRelation',

  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const storeVuex = useStore();
    const userType = computed(() => storeVuex.state.user.userType);
    console.log(userType);
    const form = ref({
      linkMan: '',
      supplierName: '',
      businessCategory: '',
      isBindCust: '',
      startTime: '',
      endTime: ''
    });
    const formRef = ref();
    const table = ref();
    const currentRow = ref(null);
    const showSeeModal = ref(false);
    const salesmanTypeList = ref([]);
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '登录账号',
        field: 'loginName'
      }, {
        title: '联系人',
        field: 'linkMan'
      }, {
        title: '所属团队',
        field: 'supplierName'
      }, {
        title: '联系电话',
        field: 'linkPhone'
      }, {
        title: '更新时间',
        field: 'updateAtStr'
      }, {
        title: '操作',
        width: '160px',
        fixed: 'right',
        slots: {
          default: 'operation'
        }
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getSalesmanCustomList(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value)).then(data => {
              data === null || data === void 0 ? void 0 : data.rows.forEach(item => {
                item.isBindCustText = item.isBindCust === 1 ? '是' : '否';
              });
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    getSpecifiedSalesmanType({}, {
      params: {
        flag: 1
      }
    }).then(data => {
      if (data !== null && data !== void 0 && data.length) {
        let list = data;

        if (userType.value === 3) {
          list = data.filter(v => v.id !== '3');
        }

        salesmanTypeList.value = list;
      }
    });

    function reset() {
      var _formRef$value;

      (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.resetFields();
      table.value.commitProxy('reload');
    }

    function clearRelations() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm(`确认要清除这${selectRows.length}个业务员的客户关系吗?`).then(() => {
        clearRelation({
          activityId: selectRows.map(item => item.supUserId).join(','),
          moduleType: 20,
          readFromBackup: 0,
          __repeat: true,
          __warn: true
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            table.value.commitProxy('query');
          }
        });
      });
    }

    function see(row) {
      currentRow.value = row;
      showSeeModal.value = true;
    }

    function edit(row) {
      router.push({
        name: 'EditCustomerManage',
        query: {
          from: route.name,
          linkMan: row.linkMan,
          supplierName: row.supplierName,
          supAccountId: row.supAccountId
        }
      }, true); // backupDataByActivityId({ supUserId: row.supUserId, __warn: true }).then(
      //   (res) => {
      //     if (res.success) {
      //       router.push({
      //         name: 'EditCustomerManage',
      //         query: {
      //           id: row.supUserId,
      //           from: route.name,
      //           linkMan: row.linkMan,
      //           supplierName: row.supplierName
      //         }
      //       });
      //     }
      //   }
      // );
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        model: form.value,
        ref_key: "formRef",
        ref: formRef,
        "label-width": "100px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "业务员",
              prop: "linkMan"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.linkMan,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.linkMan = $event),
                placeholder: "账号/联系人"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "所属团队",
              prop: "supplierName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.supplierName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.supplierName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "业务员类别",
              prop: "businessCategory"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.businessCategory,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.businessCategory = $event)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(salesmanTypeList.value, type => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: type.id,
                    label: type.text,
                    value: type.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "更新开始时间",
              prop: "startTime"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.startTime,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.startTime = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "开始时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "更新结束时间",
              prop: "endTime"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.endTime,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.endTime = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "结束时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[5] || (_cache[5] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
        ref_key: "table",
        ref: table
      }), {
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Edit",
          onClick: $event => edit(row)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16), _createVNode(BindCustomerInfoModal, {
        modelValue: showSeeModal.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => showSeeModal.value = $event),
        supUserId: currentRow.value ? currentRow.value.supUserId : ''
      }, null, 8, ["modelValue", "supUserId"])]);
    };
  }

};